"use strict";
var _a;
exports.__esModule = true;
exports.WidgetTypeFamilyToTypesMap = exports.WidgetTypeFamily = exports.WidgetType = exports.UnitDimensionType = exports.UnitType = exports.GroupBy = exports.TrendDirection = void 0;
var TrendDirection;
(function (TrendDirection) {
    TrendDirection[TrendDirection["Asc"] = 0] = "Asc";
    TrendDirection[TrendDirection["Desc"] = 1] = "Desc";
})(TrendDirection = exports.TrendDirection || (exports.TrendDirection = {}));
var GroupBy;
(function (GroupBy) {
    GroupBy[GroupBy["Merchant"] = 0] = "Merchant";
    GroupBy[GroupBy["Team"] = 1] = "Team";
    GroupBy[GroupBy["ParentTeam"] = 2] = "ParentTeam";
    GroupBy[GroupBy["Driver"] = 3] = "Driver";
    GroupBy[GroupBy["Fleet"] = 4] = "Fleet";
})(GroupBy = exports.GroupBy || (exports.GroupBy = {}));
var UnitType;
(function (UnitType) {
    UnitType[UnitType["Percent"] = 0] = "Percent";
    UnitType[UnitType["Distance"] = 1] = "Distance";
    UnitType[UnitType["Money"] = 2] = "Money";
    UnitType[UnitType["Number"] = 3] = "Number";
    UnitType[UnitType["Time"] = 4] = "Time";
})(UnitType = exports.UnitType || (exports.UnitType = {}));
var UnitDimensionType;
(function (UnitDimensionType) {
    UnitDimensionType[UnitDimensionType["Weekday"] = 0] = "Weekday";
    UnitDimensionType[UnitDimensionType["Hour"] = 1] = "Hour";
})(UnitDimensionType = exports.UnitDimensionType || (exports.UnitDimensionType = {}));
var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["Number"] = 0] = "Number";
    WidgetType[WidgetType["LineChart"] = 1] = "LineChart";
    WidgetType[WidgetType["BarChart"] = 2] = "BarChart";
    WidgetType[WidgetType["PieChart"] = 3] = "PieChart";
    WidgetType[WidgetType["DonutChart"] = 4] = "DonutChart";
    WidgetType[WidgetType["ReversedBarChart"] = 5] = "ReversedBarChart";
})(WidgetType = exports.WidgetType || (exports.WidgetType = {}));
var WidgetTypeFamily;
(function (WidgetTypeFamily) {
    WidgetTypeFamily[WidgetTypeFamily["Number"] = 0] = "Number";
    WidgetTypeFamily[WidgetTypeFamily["Line"] = 1] = "Line";
    WidgetTypeFamily[WidgetTypeFamily["Pie"] = 2] = "Pie";
})(WidgetTypeFamily = exports.WidgetTypeFamily || (exports.WidgetTypeFamily = {}));
exports.WidgetTypeFamilyToTypesMap = (_a = {},
    _a[WidgetTypeFamily.Number] = [WidgetType.Number],
    _a[WidgetTypeFamily.Line] = [WidgetType.LineChart, WidgetType.BarChart, WidgetType.ReversedBarChart],
    _a[WidgetTypeFamily.Pie] = [WidgetType.DonutChart, WidgetType.PieChart],
    _a);
//# sourceMappingURL=widgets.js.map